export const promiseAction = (type) => (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type,
        payload,
        resolve,
        reject,
      });
    });
  };
};
